export default __webpack_public_path__ + "static/media/010-drone.6f4b9bdb.svg";